import { Injectable } from '@angular/core';
import {HttpClientService} from '../httpClient/httpclient.service';
import {Currency} from '../../models/currencies.model';
import 'rxjs/Rx';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class CurrenciesService {

  currencies: Currency[];
  currencyEditing: Currency;
  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<any> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.getPaged('/koncentro-common/currency/currencies' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

  getAll() {
    return this.h.get('/koncentro-common/currency/currencies')
      .map(res => {
        return this.currencies = res;
      });
  }

  delete(record) {
    return this.h.delete('/koncentro-common/currency/currencies/' + record.id)
      .map(res => {
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Currency deleted'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-common/currency/currencies', newData)
      .map(res => {
        newData.id = res.id;
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData) {
    return this.h.put('/koncentro-common/currency/currencies', newData)
      .map(res => {
        Object.assign(this.currencyEditing, newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/CurrencyDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/currencies/currencies.service.ts